import React from 'react';

const GalleryVideoItem = ({ video, index, keyPrefix = '' }) => (
  <div className="gallery-item video-item" style={{ background: 'transparent' }}>
    {video.youtube_id ? (
      <>
        <div
          className="youtube-video-container"
          onClick={(e) => {
            const url = video.youtube_url || `https://www.youtube.com/watch?v=${video.youtube_id}`;
            e.preventDefault();
            e.stopPropagation();
            window.open(url, '_blank');
          }}
          style={{
            position: 'relative',
            width: '100%',
            paddingBottom: '56.25%',
            cursor: 'pointer',
            borderRadius: '8px',
            overflow: 'hidden',
            background: '#000',
            marginBottom: '0',
          }}
        >
          <img
            src={video.thumbnail}
            alt={video.title}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: '#ff0000',
              fontSize: '3rem',
              textShadow: '0 2px 8px rgba(0,0,0,0.8)',
              transition: 'transform 0.2s ease',
              zIndex: 1,
            }}
          >
            <i className="fab fa-youtube"></i>
          </div>
        </div>
        <div
          style={{
            padding: '12px 8px 0',
            background: '#fff',
            borderRadius: '0 0 8px 8px',
          }}
        >
          <h4
            style={{
              margin: 0,
              fontSize: '0.95rem',
              fontWeight: '600',
              color: '#1e293b',
              lineHeight: '1.4',
            }}
          >
            {video.title}
          </h4>
        </div>
      </>
    ) : (
      <div className="gallery-placeholder">
        <i className={video.icon || 'fas fa-play-circle'}></i>
      </div>
    )}
  </div>
);

export default GalleryVideoItem;
